var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12.08C0 18 4.32 22.96 10 23.92l.08-.06v-8.42H7.04v-3.36H10V9.44c0-2.96 1.92-4.64 4.64-4.64q1.32 0 2.64.24v3.04h-1.52c-1.44 0-1.76.72-1.76 1.68v2.32h3.2l-.56 3.36h-2.56v8.47c5.64-1 9.92-5.94 9.92-11.83 0-6.56-5.44-12-12-12s-12 5.44-12 12"
  })));
};
export default SvgFacebook;